import { render, staticRenderFns } from "./PurchaseCompleted.vue?vue&type=template&id=c728acda&scoped=true&"
import script from "./PurchaseCompleted.vue?vue&type=script&lang=js&"
export * from "./PurchaseCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCompleted.vue?vue&type=style&index=0&id=c728acda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c728acda",
  null
  
)

export default component.exports